<section class="blog__cards">
    <div class="blog__cards__content pb-4">
        <div class="blog__cards__content__container container">
            <div
                class="blog__cards__content__container__title row d-flex align-items-center h-100"
            >
                <h2
                    class="blog__cards__content__container__title__text col-slmd-8 pt-4 py-slmd-4 m-0 justify-content-center text-center text-slmd-start"
                >
                    {{ 'fe_landing_blog_alamo_mexico' | translate }}
                </h2>
                <div
                    class="col-slmd-4 py-slmd-4 d-flex justify-content-center justify-content-slmd-end"
                >
                    <fe-button
                        [style]="'link-tertiary'"
                        [href]="'/blog'"
                        [target]="'_blank'"
                    >
                        <span
                            class="blog__cards__content__container__title__href"
                        >
                            {{ 'fe_landing_blog_alamo_blog' | translate }}
                        </span>
                    </fe-button>
                </div>
            </div>
            <div class="blog__cards__content__container__extra row">
                <ng-container *ngIf="!blog; else blogContent">
                    <div
                        *ngFor="let placeholder of placeholders"
                        class="blog__cards__content__container__extra__img col-12 col-sm-6 col-lg-4 d-flex flex-column placeholder-wave"
                    >
                        <a>
                            <img
                                [src]="'assets/images/nopic.webp' | cdn"
                                alt="Loading Placeholder"
                                class="mb-3 force-ratio placeholder"
                            />
                        </a>
                        <a class="placeholder">{{
                            'fe_landing_blog_alamo_placeholder' | translate
                        }}</a>
                    </div>
                </ng-container>
                <ng-template #blogContent>
                    <div
                        *ngFor="let blogItem of blog?.data?.news"
                        class="blog__cards__content__container__extra__img col-12 col-sm-6 col-lg-4 d-flex flex-column"
                        [ngClass]="{
                            'placeholder placeholder-wave': !blogItem.title
                        }"
                    >
                        <a [href]="blogItem.url" class="mb-2">
                            <img
                                (error)="onImageError($event)"
                                [src]="
                                    blogItem.img || ('images/nopic.webp' | cdn)
                                "
                                [alt]="blogItem.title || 'Placeholder Image'"
                                class="force-ratio"
                            />
                        </a>
                        <a [href]="blogItem.url" class="mb-4">{{
                            blogItem.title ||
                                'fe_landing_blog_alamo_placeholder' | translate
                        }}</a>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</section>
